import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  ArrowRight,
  ChevronDown,
  MessageCircle,
  Mail,
  Phone,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { api } from "../../../store/slices/authSlice";
import styles from "./HelpPage.module.css";

export default function HelpPage() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.startsWith("ar");

  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await api.get("/faq", {
          headers: { "Accept-Language": i18n.language },
        });
        if (res.data.code === 200) setFaqs(res.data.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [i18n.language]); 

  return (
    <div className={styles.page} dir={isRtl ? "rtl" : "ltr"}>
      <div className={styles.pageHeader}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          {isRtl ? <ArrowRight size={18} /> : <ArrowLeft size={18} />}
        </button>
        <h1 className={styles.pageTitle}>{t("help.title")}</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.contactCard}>
          <h2 className={styles.contactTitle}>{t("help.contactTitle")}</h2>
          <p className={styles.contactSub}>{t("help.contactSub")}</p>

          <div className={styles.channels}>
            <a
              href="https://wa.me/201000000000"
              target="_blank"
              rel="noreferrer"
              className={styles.channel}
            >
              <MessageCircle size={24} />
              <span>{t("help.whatsapp")}</span>
            </a>

            <a href="mailto:support@rawkemya.com" className={styles.channel}>
              <Mail size={24} />
              <span>{t("help.email")}</span>
            </a>

            <a href="tel:+201000000000" className={styles.channel}>
              <Phone size={24} />
              <span>{t("help.phone")}</span>
            </a>
          </div>
        </div>

        <div className={styles.faqSection}>
          <h3 className={styles.faqTitle}>
            <span className={styles.faqBar} />
            {t("help.faqs")}
          </h3>

          {loading ? (
            <div className={styles.faqGroup}>
              {[...Array(4)].map((_, i) => (
                <div key={i} className={styles.faqSkeleton} />
              ))}
            </div>
          ) : (
            <div className={styles.faqGroup}>
              {faqs.map((faq, i) => (
                <div key={i}>
                  {i > 0 && <div className={styles.faqDivider} />}
                  <button
                    className={styles.faqQuestion}
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  >
                    <span>{faq.question}</span>
                    <ChevronDown
                      size={18}
                      className={`${styles.faqChevron} ${
                        openIndex === i ? styles.faqChevronOpen : ""
                      }`}
                    />
                  </button>
                  {openIndex === i && (
                    <p className={styles.faqAnswer}>{faq.answer}</p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
